import axios from 'axios';
import * as Constants from './configuration';
import { getRegionCode } from '../utils/get-region-details';

export function getCountryList(typeOfUsage) {
  return (dispatch) =>
    axios
      .get(Constants.REGISTER_USER_ACTION.GET_COUNTRY_LIST, {
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          typeOfUsage: typeOfUsage
        }
      })
      .then((response) => {
        dispatch({
          type: 'COUNTRY_LIST',
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
}

export function getRegionSpecificCountryList() {
  const regionCode = getRegionCode();
  return (dispatch) =>
    axios
      .get(
        Constants.REGISTER_USER_ACTION.GET_COUNTRY_LIST_USER_ONBOARD +
          `${regionCode}?typeOfUsage=USER_ONBOARD`,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        dispatch({
          type: 'REGION_SPECIFIC_COUNTRY_LIST',
          payload: response.data?.sort((item1, item2) =>
            item1.countryName.localeCompare(item2.countryName)
          )
        });
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
}
